/**
 * Formats a number using Norwegian locale formatting.
 * Returns "Ubegrenset" for null values.
 *
 * @param num - The number to format, or null for unlimited
 * @returns Formatted number string or "Ubegrenset"
 *
 * @example
 * formatNumber(1000) // "1 000"
 * formatNumber(null) // "Ubegrenset"
 */
export const formatNumber = (num: number | null): string => {
  if (num === null) return 'Ubegrenset';
  return num.toLocaleString('no-NO');
};

/**
 * Formats a number using Norwegian locale formatting.
 * Returns infinity symbol (∞) for null values.
 *
 * @param num - The number to format, or null for unlimited
 * @returns Formatted number string or "∞"
 *
 * @example
 * formatNumberInfinite(1000) // "1 000"
 * formatNumberInfinite(null) // "∞"
 */
export const formatNumberInfinite = (num: number | null): string => {
  if (num === null) return '∞';
  return num.toLocaleString('no-NO');
};
